import React, { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom';

import NavbarMain from '../../config/component/layouts/NavbarMain';
import MainRouters from '../../config/routes';
import PageNotFoundComponent from '../main/view/error_handling/PageNotFoundComponent';

import { useMainViewModel } from '../main/viewmodel/main/MainViewModel';
import { onShowLoading } from '../../config/utils/alerts';
import { ThemeProvider } from '@mui/material';
import { database, onValue, ref } from '../../config/utils/firebase';
import UnderMaintenanceComponent from '../main/view/error_handling/UnderMaintenanceComponent';

export const Routers = () => {
  const [maintenanceMode, setMaintenanceMode] = React.useState(false);

  const { searchQuery, handleSearch, themeState, isDirectPage, isHideNavbar } = useMainViewModel();

  React.useEffect(() => {
    const maintenanceRef = ref(database, "maintenanceMode");
    onValue(maintenanceRef, (snapshot) => {
      const isMaintenance = snapshot.val();
      setMaintenanceMode(isMaintenance);
    });

  }, []);

  if (maintenanceMode) {
    return (
      <>
        <UnderMaintenanceComponent />
      </>
    );
  }

  return (
    <div>
      <ThemeProvider theme={themeState}>
        <Suspense fallback={
          onShowLoading(true)
        }>
          <div className='main'>
            <NavbarMain onSearch={handleSearch} isDirectPage={isDirectPage} isHideNavbar={isHideNavbar} />
            <Routes>
              {MainRouters.map(({ key, path, component: Component }) => (
                <Route
                  path={path}
                  key={key}
                  element={
                    <Component
                      query={searchQuery}
                    />
                  }
                />
              ))}
              <Route path="*" key={"key.404NotFound"} element={<PageNotFoundComponent />} />
            </Routes>
          </div>
        </Suspense>
      </ThemeProvider>
    </div>
  )
}
